export const TOKEN_ADDRESS = "0x0b3eE85E3419ed38A7D00a56010237aA9a712CdC";
export const WALLET_TO_TRACK = "0x1E29B1dd7eFF8cf33Fc5DEb27b76ca734D7D95E6";
export const ERC20_ABI = ["function balanceOf(address owner) view returns (uint256)"];
export const TOKEN_SUPPLY = 2500000000;